import React from 'react';
import { Loading, Alert, Tag } from './../../../components/ui';
import { List, ListItem, ListItemText, ListItemSecondaryAction } from './../../../assets/theme/list';
import { PermissionService } from './../../../services';
import { isStatus, isStatusColor } from './../../../utilities/utils';

import TEXT from './../../../config/text';

class PermissionList extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      error: false,
      entities: []
    };
  }

  /**
  * @Event
  * @Description: Is invoked immediately after a component is mounted.
  */
  componentDidMount(){
    this._Find();
  }

  /*
  ** @Service
  ** @Description: Find permissions by ids
  */

  _Find = () => {

    PermissionService.listByIds({ ids: JSON.stringify(this.props.ids) }).then((response) => {

      // @Store
      // @Description: Set state
      this.setState({ loading: true, entities: response.permissions });

    }).catch((error) => {

      // @Store
      // @Description: Set state
      this.setState({ loading: true, error: true });

    });

  }

  render() {

    const { loading, error, entities } = this.state;

    return(
      <React.Fragment>

        { loading ? (

          !error ? (

            entities.length > 0 ? (

              <List
                component="ul"
                dense
                disablePadding
              >
                { entities.map(entity => {
                  return(
                    <ListItem key={ entity._id } divider disableGutters>
                      <ListItemText primary={ entity.name } />
                      <ListItemSecondaryAction>
                        <Tag
                          text={ isStatus(entity.enabled) }
                          color={ isStatusColor(entity.enabled) }
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  )
                })}
              </List>

            ) : (

              <Alert severity="info">
                Este usuario no cuenta con ningun permiso asignado.
              </Alert>

            )

          ) : (

            <Alert severity="error">
              { TEXT.message.error }
            </Alert>

          )

        ) : (
          <Loading/>
        )}

      </React.Fragment>
    )
  }

}

export default PermissionList;
